export default function getCardActivityReducer(state ={cardactivity:{}} ,action){
    switch (action.type) {
        case 'CARD_ACTIVITY':
        return {
            cardactivity:action.payload
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/getcardactivityreducer.jsx